module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/paralynpic-committee-e3e9c73063a623d35dd5ae3f3db41631.png";